import { IUserAnswer } from 'components/courses/lessons/components/LessonCard/components/ContentBlock/components/evaluation/Evaluation'
import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IBlockInstanceModel } from 'models/block.model'
import { EvaluationResult } from 'models/evaluationResult.model'

export const SEND_EVALUATION = 'SEND_EVALUATION'

export interface PayloadSendEvaluation {
  answers: IUserAnswer[]
  courseId: string | number
  blockEvaluationId: number
  blockInstanceId: number
  lessonId: number
  blockInstances: IBlockInstanceModel[]
  onSuccess?: (data: EvaluationResult) => void
  onError?: (e: any) => void
}

export const Actions = {
  sendEvaluation: (data: PayloadSendEvaluation) =>
    createAction(SEND_EVALUATION, data),
}

export type Actions = ActionsUnion<typeof Actions>
